/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-test-group-item.reducer';

export const LabTestGroupItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labTestGroupItemEntity = useAppSelector(state => state.labTestGroupItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labTestGroupItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labTestGroupItem.detail.title">LabTestGroupItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labTestGroupItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{labTestGroupItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labTestGroupItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{labTestGroupItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.labTestGroupItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{labTestGroupItemEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labTestGroupItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labTestGroupItemEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.labTestGroupItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{labTestGroupItemEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labTestGroupItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labTestGroupItemEntity.cursor}</dd>
          <dt>
            <span id="testType">
              <Translate contentKey="tinyMedicRestApp.labTestGroupItem.testType">Test Type</Translate>
            </span>
          </dt>
          <dd>{labTestGroupItemEntity.testType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestGroupItem.lcGroupItem">Lc Group Item</Translate>
          </dt>
          <dd>{labTestGroupItemEntity.lcGroupItem ? labTestGroupItemEntity.lcGroupItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestGroupItem.lcTestCategory">Lc Test Category</Translate>
          </dt>
          <dd>{labTestGroupItemEntity.lcTestCategory ? labTestGroupItemEntity.lcTestCategory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestGroupItem.panel">Panel</Translate>
          </dt>
          <dd>{labTestGroupItemEntity.panel ? labTestGroupItemEntity.panel.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestGroupItem.imageTest">Image Test</Translate>
          </dt>
          <dd>{labTestGroupItemEntity.imageTest ? labTestGroupItemEntity.imageTest.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-test-group-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-test-group-item/${labTestGroupItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabTestGroupItemDetail;
